import { createAsyncThunk } from "@reduxjs/toolkit";
import fsrHttpInstance, { fsrHttpConfiguration } from "../serviceFsrClients";
import { normalizeEntity } from "../entities/paymentCategoryEntity";
import { setFlashSuccess, setFlashError } from "../slices/commons/flashSliceCommon";

export const fetchPaymentCategories = createAsyncThunk(
	"datasources/paymentCategories/fetchPaymentCategories",
	async (request, thunkAPI) => {
		try {
			const params = request ? { params: request.query } : {};
			const response = await fsrHttpInstance.then(fsrService => fsrService.get("vendor/payment-categories/index", {...params, ...fsrHttpConfiguration()}));
			const normalized = normalizeEntity(response.data.paymentCategories);
			
			return { 
				...normalized, 
				pagination: response.data.pagination || {} 
			};
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The payment category could not be loaded. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);

export const fetchPaymentCategory = createAsyncThunk(
	"datasources/paymentCategories/fetchPaymentCategory",
	async (request, thunkAPI) => {
		try {
			const params = request ? { params: request.query } : {};
			const response = await fsrHttpInstance.then(fsrService => fsrService.get("vendor/payment-categories/view", {...params, ...fsrHttpConfiguration()}));
			const normalized = normalizeEntity(response.data.paymentCategory);
			
			return normalized;
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The payment category could not be loaded. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);

export const savePaymentCategory = createAsyncThunk(
	"datasources/paymentCategories/savePaymentCategory",
	async (request, thunkAPI) => {
		try {
			const formData = { ...request };
			const action = formData.id ? "edit" : "add";
			const response = await fsrHttpInstance.then(fsrService => fsrService.post(`vendor/payment-categories/${action}`, formData, fsrHttpConfiguration()));

			thunkAPI.dispatch(setFlashSuccess("The payment category has been saved."));
			return response.data;
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The payment category could not be saved. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);

export const deletePaymentCategory = createAsyncThunk(
	"datasources/paymentCategories/deletePaymentCategory",
	async (request, thunkAPI) => {
		try {
			const params = request.query ? { params: request.query } : {};
			const response = await fsrHttpInstance.then(fsrService => fsrService.post("vendor/payment-categories/delete", null, {...params, ...fsrHttpConfiguration()}));

			thunkAPI.dispatch(setFlashSuccess("The payment category has been deleted."));
			return response.data;
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The payment category could not be deleted. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);